const TAB_NAMES = {
  HOLD_REASONS: "Hold Reasons",
  RESCHEDULE_REASONS: "Reschedule Reasons",
};

export const ROUTE_NAMES = {
  HOLD_REASONS: "hold-reasons",
  RESCHEDULE_REASONS: "reschedule-reasons",
};

export const TAB_LIST = [
  {
    name: TAB_NAMES.HOLD_REASONS,
    value: ROUTE_NAMES.HOLD_REASONS,
    label: TAB_NAMES.HOLD_REASONS,
  },
  {
    name: TAB_NAMES.RESCHEDULE_REASONS,
    value: ROUTE_NAMES.RESCHEDULE_REASONS,
    label: TAB_NAMES.RESCHEDULE_REASONS,
  },
];

export const REASON_TYPES = {
  HOLD: "holdReasons",
  RESCHEDULE: "rescheduleReasons",
};
